import { createReducer } from '@reduxjs/toolkit';
import { avatarEmpty } from '@utils/constants.js';

import { layoutTypes, sectionType } from '/src/views/AdminPanelView/components/AdminPanel/components/EmailMarketing/utils/enums';

import * as headerActions from './headerActions.js';

const initialState = {
  requesting: false,
  error: null,

  id: 0,
  uid: 0,
  type: sectionType.header,
  isActive: false,

  image: avatarEmpty,
  imageSize: 100,
  imageShape: 'round',
  link: '',
  name: '',
  nameSize: 24,
  view: layoutTypes.full,
};

const header = createReducer(initialState, (builder) => {
  builder
    .addCase(headerActions.headerUpdateId, (state, { payload: id }) => ({ ...state, id }))
    .addCase(headerActions.headerUpdateIsActive, (state, { payload: isActive }) => ({ ...state, isActive }))

    .addCase(headerActions.headerStore, (state, { payload: data }) => {
      const {
        blockId,
        uid,
        isActive,

        header,
      } = data;

      const section = header ?? {};
      const { image, imageShape, imageSize, imageHyperlink: link, text: name, textSize: nameSize, view } = section;

      return {
        ...state,

        error: null,
        requesting: false,

        id: blockId ?? 0,
        uid: uid ?? 0,
        isActive: isActive,

        image: image ?? '',
        imageSize: imageSize ?? 100,
        imageShape: imageShape ?? 'round',

        link: link ?? '',
        name: name ?? '',
        nameSize: nameSize ?? 24,
        view: view ?? layoutTypes.full,
      };
    })
    .addCase(headerActions.headerClear, () => ({ ...initialState }))

    .addCase(headerActions.headerUpdateRequest, (state) => ({ ...state, requesting: true, error: null }))
    .addCase(headerActions.headerUpdateError, (state, { payload }) => ({ ...state, error: payload, requesting: false }))
    .addCase(headerActions.headerUpdateStore, (state) => ({ ...state, error: false, requesting: false }))

    .addCase(headerActions.headerUpdateImage, (state, { payload: image }) => ({ ...state, image }))
    .addCase(headerActions.headerUpdateImageSize, (state, { payload: imageSize }) => ({ ...state, imageSize }))
    .addCase(headerActions.headerUpdateImageShape, (state, { payload: imageShape }) => ({ ...state, imageShape }))

    .addCase(headerActions.headerUpdateLink, (state, { payload: link }) => ({ ...state, link }))
    .addCase(headerActions.headerUpdateName, (state, { payload: name }) => ({ ...state, name }))
    .addCase(headerActions.headerUpdateNameSize, (state, { payload: nameSize }) => ({ ...state, nameSize }))
    .addCase(headerActions.headerUpdateView, (state, { payload: view }) => ({ ...state, view }));
});

export default header;
